export default __webpack_public_path__ + "images/Lukas_Will_4.webp?570f6611c572cd20b891b5ce9c9dd83b";